export function enumToOptions<T extends Record<string, string>>(enumObj: T): { label: string; value: keyof T }[] {
  return Object.entries(enumObj).map(([value, label]) => ({
    label,
    value: value as keyof T,
  }));
}

export function arrayStringToOptions(array: string[]): { label: string; value: string }[] {
  return array.map((value) => ({
    label: value,
    value,
  }));
}
